export function assertNever(_: never): never {
  return undefined as never
}
